import {
  TableBody,
  TableCell,
  TableFoot,
  TableHead,
  TableHeadCell,
  TableRow
} from './primitives'
import { default as Table } from './table'
import withThemeUI from '../../theme-provider/with-theme-ui'
const ThemeTable = withThemeUI(Table)

/**
 * @deprecated use RcTablesComponents instead for better performance, this will
 * require that css styling will need to be restructure to propagate from the parent node
 * of the table.
 */
const RcTableComponents = {
  table: Table,
  header: {
    wrapper: Table.Head,
    row: Table.Row,
    cell: Table.HeadCell
  },
  body: {
    wrapper: Table.Body,
    row: Table.Row,
    cell: Table.Cell
  },
  footer: {
    wrapper: Table.Foot,
    row: Table.Row,
    cell: Table.Cell
  }
}

const RcTablePrimitivesComponents = {
  table: Table,
  header: {
    wrapper: TableHead,
    row: TableRow,
    cell: TableHeadCell
  },
  body: {
    wrapper: TableBody,
    row: TableRow,
    cell: TableCell
  },
  footer: {
    wrapper: TableFoot,
    row: TableRow,
    cell: TableCell
  }
}

export * from './types'
export * from './table-context'
export { Table, ThemeTable, RcTableComponents, RcTablePrimitivesComponents }
export default Table
